export default __webpack_public_path__ + "static/media/serv-distance.d3e5843c.svg";